import { render, staticRenderFns } from "./SpecField.vue?vue&type=template&id=d79e45fa"
import script from "./SpecField.vue?vue&type=script&lang=js"
export * from "./SpecField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports